import React from 'react';

import lang from '../../lib/language';

import chartUpR from '../../assets/img/chart-up-r.svg';
import discoverLogo from '../../assets/img/icon_discover.svg';
import myAccountLogo from '../../assets/img/icon_myaccount.png';
import profileLogo from '../../assets/img/icon-profile.svg';
import watchlistLogo from '../../assets/img/icon-watchlist.svg';
import paymentLogo from '../../assets/img/payment-logo.svg';
import { UI_ROUTES } from '../../util/routes';

import { DownBarIdType, DownBarItem } from './Downbar.types';

export const MENU_LIST: DownBarItem[] = [
  {
    id: DownBarIdType.FundPortal,
    label: lang.commonPortalsFundPortal(),
    path: '/alaric-bg',
    img: <img src={chartUpR} alt="icon fund portal" />,
  },
  {
    id: DownBarIdType.Watchlist,
    label: lang.commonWatchlist(),
    path: '/overview',
    img: <img src={watchlistLogo} alt="icon watchlist" />,
  },
  {
    id: DownBarIdType.Discover,
    label: lang.commonDiscoverTitle(),
    path: '/discover',
    img: <img src={discoverLogo} alt="icon discover" />,
  },
  {
    id: DownBarIdType.MyAccount,
    label: lang.commonMyAccount(),
    path: '/my-account',
    img: <img src={myAccountLogo} alt="icon my account" />,
  },
  {
    id: DownBarIdType.Funds,
    label: lang.fundsScreenTitle(),
    path: UI_ROUTES.funds + UI_ROUTES.makeYourFirstDeposit,
    img: <img src={paymentLogo} alt="icon payment" />,
  },
  {
    id: DownBarIdType.MyProfile,
    label: lang.mobileProfileMyProfile(),
    path: '/my-profile',
    img: <img src={profileLogo} alt="icon my profile" />,
  },
];
